import * as Yup from 'yup';
import kecamatanFormModel from './kecamatanFormModel';

const {
  formField: {
    kode,
    nama
  }
} = kecamatanFormModel;

export default Yup.object({
  [kode.name]: Yup.string().required(`${kode.requiredErrorMsg}`),
  [nama.name]: Yup.string().required(`${nama.requiredErrorMsg}`)
});
